"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Battery = function Battery(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,3H14.5V.5A.5.5,0,0,0,14,0H10a.5.5,0,0,0-.5.5V3H8A2.5,2.5,0,0,0,5.5,5.5v16A2.5,2.5,0,0,0,8,24h8a2.5,2.5,0,0,0,2.5-2.5V5.5A2.5,2.5,0,0,0,16,3ZM10.5, 1h3V3h-3Zm-4,4.5A1.5,1.5,0,0,1,8,4h8a1.5,1.5,0,0,1,1.5,1.5V9H6.5Zm7,15.5h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.5,6h-1V5a.5.5,0,0,0-1,0V6h-1a.5.5,0,0,0,0,1h1V8a.5.5,0,0,0,1,0V7h1a.5.5,0,0,0,0-1Z",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = Battery;
exports["default"] = _default;